module.exports = __webpack_public_path__ + "img/solution2.f646da2d.png";